import React from 'react';
import './loader.css'

const Loader = () => {
    return (
      <section class="dots-container">
        <div class="dot"></div>
        <div class="dot"></div>
        <div class="dot"></div>
        <div class="dot"></div>
        <div class="dot"></div>
      </section>
    );
}

export default Loader;